<template>
  <div class="modal-overlay" @click="$emit('close')">
    <div class="modal" @click.stop>
      <h2>Create an Account</h2>
      
      <div v-if="alert.message" :class="['alert', alert.type === 'success' ? 'alert-success' : 'alert-error']">
        {{ alert.message }}
      </div>
      
      <form @submit.prevent="handleRegister">
        <div class="form-group">
          <label for="register-username">Username</label>
          <input 
            type="text" 
            id="register-username" 
            v-model="form.username" 
            placeholder="Enter your username" 
            required>
        </div>
        
        <div class="form-group">
          <label for="register-email">Email</label>
          <input 
            type="email" 
            id="register-email" 
            v-model="form.email" 
            placeholder="Enter your email" 
            required>
        </div>
        
        <div class="form-group">
          <label for="register-password">Password</label>
          <input 
            type="password" 
            id="register-password" 
            v-model="form.password" 
            placeholder="Enter your password" 
            required>
        </div>
        
        <div class="form-group">
          <label for="register-confirm-password">Confirm Password</label>
          <input 
            type="password" 
            id="register-confirm-password" 
            v-model="form.confirmPassword" 
            placeholder="Confirm your password" 
            required>
        </div>
        
        <div class="form-buttons">
          <button type="submit" class="btn-primary" :disabled="loading">
            <span v-if="loading" class="spinner"></span>
            <span v-else>Register</span>
          </button>
          <button type="button" class="btn-secondary" @click="$emit('close')">Cancel</button>
        </div>
        
        <p style="text-align: center; margin-top: 15px;">
          Already have an account? 
          <a href="#" style="color: #4dabf7;" @click.prevent="$emit('switch-to-login')">
            Login here
          </a>
        </p>
      </form>
    </div>
  </div>
</template>

<script>
// Mock API (实际项目中应该调用真实的API)
const mockApi = {
  register: function(userData) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (userData.password !== userData.confirmPassword) {
          reject({
            success: false,
            message: 'Passwords do not match'
          });
          return;
        }
        
        if (userData.email === 'existing@roadlink.com') {
          reject({
            success: false,
            message: 'Email already exists'
          });
          return;
        }
        
        resolve({
          success: true,
          user: {
            id: Math.floor(Math.random() * 1000),
            username: userData.username,
            email: userData.email
          },
          token: 'mock_jwt_token_' + Math.floor(Math.random() * 10000)
        });
      }, 1500);
    });
  }
};

export default {
  name: 'RegisterModal',
  data() {
    return {
      loading: false,
      form: {
        username: '',
        email: '',
        password: '',
        confirmPassword: ''
      },
      alert: {
        message: '',
        type: ''
      }
    }
  },
  methods: {
    async handleRegister() {
      this.loading = true;
      this.alert.message = '';
      
      try {
        const response = await mockApi.register(this.form);
        
        if (response.success) {
          // 存储用户信息
          localStorage.setItem('user', JSON.stringify(response.user));
          localStorage.setItem('token', response.token);
          
          // 通知父组件注册成功
          this.$emit('success', response.user);
          
          this.alert.message = 'Registration successful!';
          this.alert.type = 'success';
          
          // 重置表单
          this.form = {
            username: '',
            email: '',
            password: '',
            confirmPassword: ''
          };
        }
      } catch (error) {
        this.alert.message = error.message;
        this.alert.type = 'error';
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  padding: 30px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
}

.modal h2 {
  color: #1a3a5f;
  margin-bottom: 20px;
  text-align: center;
}

.form-buttons {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.alert {
  padding: 12px 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.alert-success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.alert-error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255,255,255,.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>